import React from 'react';
import './Experince.modules.css'; // Import custom CSS for styling
import line from "../../../images/Travelicons/line_for_brief_section[1].svg"
const ExperienceSection = () => {
  return (
    <section className="experience-section">
      <div className="content">
        <h1>Experience the Difference: Travel With Us</h1>
        <span><img src={line} alt="" className=''style={{width:"350px"}}/></span>
        <p className='text-white'>
          Empowering Youth and Unleashing Their Limitless Potential through a lifetime experience in
          the holy lands of Meccah and Medinah and international camps in Turkey and Spain.
        </p>
      </div>
    </section>
  );
};

export default ExperienceSection;